/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState } from 'react';
import { ProfileCardComp, Header, EditProfileModal } from '../components';
import { useSMProfilePageGetContent } from '../machines/pageContent';
import { useSMupdateProfile } from '../machines/updateprofile';

import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';

import { ProfilePageService } from '@pages/Profile/services';
import { VApplication } from '@/application';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.ProfilePageService') as ProfilePageService;
};

export const ContainerComm = (props: any) => {
  const [showModal, setShowModal] = useState(false);
  const { profilePageState, profilePageSend, profilePageMachine } =
    useSMProfilePageGetContent({});

  const staticPageContentConfig = getSrv()?.getStaticPageContent();

  const { updateProfileMachine, updateProfileSend, updateProfileState } =
    useSMupdateProfile({});

  const onEditButtonPress = () => {
    if (!showModal) {
      setShowModal(true);
    }
  };

  const onModalClose = () => {
    if (showModal) {
      setShowModal(false);
    }
  };

  const onEditProfile = (
    name: string,
    description: string,
    phoneNumber: string,
    address: string,
    website: string,
    profileImg?: string
  ) => {
    const payload: any = {};
    if (name) {
      payload.name = name;
    }
    if (description) {
      payload.description = description;
    }
    if (phoneNumber) {
      payload.telephone = phoneNumber;
    }
    if (address) {
      payload.address = {
        addressLine1: address,
      };
    }
    if (website) {
      payload.website = website;
    }
    if (profileImg) {
      payload.logo = profileImg;
    }
    updateProfileSend('START', {
      payload: payload,
    });
  };

  const onError = () => {
    profilePageSend('TRIGGER_RELOAD', {});
    // window.location.reload(false);
  };

  const onUpdateSuccess = () => {
    profilePageSend('START', {});
  };

  const _renderNotifications = () => {
    if (updateProfileState?.matches('UPDATE_PROFILE_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.updateProfileSuccess ||
            {})}
          onAcknowledgement={onError}
          onDeny={onError}
        />
      );
    }

    return null;
  };

  const _renderPage = () => {
    if (updateProfileState?.matches('UPDATE_PROFILE')) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.updateProfile || {})}
        />
      );
    }

    if (profilePageState?.matches('GET_PAGE_CONTENT')) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.loadingProfile || {})}
        />
      );
    }
    if (profilePageState?.matches('RENDER_PAGE')) {
      return (
        <>
          <ProfileCardComp
            {...(profilePageState?.event?.data?.value || {})}
            onEditButtonPress={onEditButtonPress}
          />
        </>
      );
    }

    return null;
  };

  const _renderModal = () => {
    if (showModal) {
      return (
        <EditProfileModal
          {...(profilePageState?.event?.data?.value || {})}
          showModal={showModal}
          onDeny={onModalClose}
          onAcknowledgement={onEditProfile}
        />
      );
    }
  };

  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      return (
        <>
          <Header {...(staticPageContentConfig?.header || {})} />
        </>
      );
    }
    return null;
  };

  const _renderErrorModals = () => {
    if (updateProfileState?.matches('UPDATE_PROFILE_FAILED')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.updateProfile || {})}
          onAcknowledgement={onError}
          onDeny={onError}
        />
      );
    }
    if (profilePageState?.matches('RENDER_PAGE_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.getProfile || {})}
          onAcknowledgement={onError}
          onDeny={onError}
        />
      );
    }
  };

  return (
    <>
      {_renderHeader()}
      {_renderPage()}
      {_renderErrorModals()}
      {_renderModal()}
      {_renderNotifications()}
    </>
  );
};
